<template>
  <div>
    <div class="outmain ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('set.sms.title') }}</span>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="180px" class="mar_t20">
        <el-form-item :label="$t('set.sms.aliyunSms')" :required="true">
          <el-switch v-model="form.open" active-value="1" inactive-value="2"></el-switch>
        </el-form-item>
        <el-form-item label="Access_Key_ID" :required="true">
          <el-input v-model="form.access_key_id" :placeholder="$t('set.sms.accessKeyIdPh')"></el-input>
        </el-form-item>
        <el-form-item label="Access_Key_Secret" :required="true">
          <el-input v-model="form.access_key_secret" :placeholder="$t('set.sms.accessKeySecretPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.sms.templateSign')" :required="true">
          <el-input v-model="form.sign" :placeholder="$t('set.sms.templateSignPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.sms.testPhone')" :required="true">
          <el-input v-model="form.tel" :placeholder="$t('set.sms.testPhonePh')"></el-input>
        </el-form-item>
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('set.sms.verifyCodeTemplateTitle') }}</span>
          </div>
        </div>
        <el-form-item :label="$t('set.sms.accountRegister')" :required="true">
          <el-input v-model="form.registerCode" :placeholder="$t('set.sms.templateIdPh')"></el-input>
          <el-button class="mar_l20" @click="testTel(1)">{{ $t('set.sms.sendTest') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('set.sms.changePassword')" :required="true">
          <el-input v-model="form.registerPassWord" :placeholder="$t('set.sms.templateIdPh')"></el-input>
          <el-button class="mar_l20" @click="testTel(3)">{{ $t('set.sms.sendTest') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import {
  getConfig,
  postConfig,
  testTel
} from '@/api/set';

export default {
  created() {
    this.bus.$emit('loading', true);
    this.init();
  },
  data() {
    return {
      value: false,

      form: {
        open: '2',
        access_key_id: '',
        access_key_secret: '',
        sign: '',
        tel: '',
        registerCode: '',
        findPassWord: '',
        registerPassWord: ''
      }
    };
  },
  methods: {
    async init() {
      const { data } = await getConfig({ ident: 'sms' });
      this.form = Object.assign({}, data);
      this.bus.$emit('loading', false);
    },
    async testTel(type) {
      const { msg } = await testTel({ type: type });
      this.$baseMessage(msg, 'success');
      this.init();
    },
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.ident = 'sms';
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, 'success');
          this.init();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style>
.orderpop p {
  line-height: 24px;
}

.msgtext {
  text-indent: -61px;
  padding-left: 70px;
}
</style>
